const ACTIONS_ID = 'COUNTRIES_DATA';
const actionType = {
  INTERESET_REGISTER_COUNTRIES_CODE: `${ACTIONS_ID}_INTERESET_REGISTER_COUNTRIES_CODE`,
  INTERESET_REGISTER_COUNTRIES: `${ACTIONS_ID}_INTERESET_REGISTER_COUNTRIES`
};

export const reducers = {
  [actionType.INTERESET_REGISTER_COUNTRIES_CODE]: (state, { countriesCode }) => {
    return {
      ...state,
      interestRegisterFormData: { ...state.interestRegisterFormData, countriesCode }
    };
  },
  [actionType.INTERESET_REGISTER_COUNTRIES]: (state, { countries }) => {
    return {
      ...state,
      interestRegisterFormData: { ...state.interestRegisterFormData, countries }
    };
  }
};

export const initialState = {
  interestRegisterFormData: {
    defaultCountryCode: {
      alpha2Code: 'CO',
      callingCode: '57',
      flag: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Colombia.svg',
      name: 'Colombia'
    },
    countriesCode: [],
    countries: []
  }
};
